export default {
  absoluteY: 620,
  absoluteX: 76,
  boxes: [
    {
      type: "primaryBox",
      x: 471,
      y: 140,
      strokeColor: "violet5",
      hoverColor: "violet0",
      text: "Design Research",
    },
    {
      type: "multiBox",
      x: 0,
      y: 0,
      width: 243,
      height: 288,
      fillColor: "violet0",
      text: "Discover (Primary Research)",
    },
    {
      type: "multiBox",
      x: 110,
      y: 341,
      width: 243,
      height: 153,
      fillColor: "violet0",
      text: "Types",
    },
    {
      type: "multiBox",
      x: 885,
      y: 0,
      width: 243,
      height: 243,
      fillColor: "violet0",
      text: "Explore and Experiment",
    },
    {
      type: "multiBox",
      x: 885,
      y: 296,
      width: 243,
      height: 198,
      fillColor: "violet0",
      text: "Planning and Analysis",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 57,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Interviews",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 102,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Usability Test",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 102,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Surveys",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 147,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Contextual Inquiry",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 192,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Competitive Research",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 237,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "SWOT Analysis",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 126,
      y: 398,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Qualitative Research",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 126,
      y: 443,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Quantitative Research",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 901,
      y: 57,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Task Analysis",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 901,
      y: 102,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Analytics",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 901,
      y: 147,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "A/B Testing",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 901,
      y: 192,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Card Sorting",
      hoverColor: "violet1",
    },

    {
      type: "tertiaryBox",
      x: 901,
      y: 353,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Research Planning",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 901,
      y: 398,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Analysis of Findings",
      hoverColor: "violet1",
    },
    {
      type: "tertiaryBox",
      x: 901,
      y: 443,
      width: 211,
      fillColor: "violet0",
      strokeColor: "violet3",
      text: "Research Repository",
      hoverColor: "violet1",
    },
  ],
};
